export const APPLICATIONS_SECTIONS = {
  SECTION_CV: 'SECTION_CV',
  SECTION_BACKGROUND: 'SECTION_BACKGROUND',
  SECTION_PERSONAL_STATEMENT: 'SECTION_PERSONAL_STATEMENT',
  SECTION_PORTFOLIO: 'SECTION_PORTFOLIO',
}
